import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import TopBar from "../TopBar/TopBar";
import { DASHBOARD_STACK } from "../../utils/screenNames";

const DashboardLayout = () => {
  const location = useLocation();
  const { editingOrganisation } = useSelector((state) => state.organisation);

  const handleEditComplete = () => {
    // This will be handled by the Organisations component
  };

  return (
    <div className="bg-primary wrapper h-screen overflow-hidden flex flex-col">
      {/* <Sidebar /> */}
      <main className="comp flex-1 min-h-0 flex flex-col">
        <header>
          <TopBar
            editingOrganisation={editingOrganisation}
            onEditComplete={handleEditComplete}
          />
        </header>
        <div className="main-content-body flex-1 min-h-0 overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
